import React, { useCallback, useMemo, useRef, useState } from 'react';

import { NavigationBlockerContext } from './NavigationBlocker.decl';

import { Transition } from 'history';

export function NavigationBlockerProvider({ children }: { children: React.ReactNode }) {
  /** Whether we should display a message prompt to users */
  const [navPromptShown, setNavPromptShown] = useState(false);
  const blockedTransition = useRef<Transition | null>(null);

  const confirmNavigation = useCallback(() => {
    setNavPromptShown(false);

    if (blockedTransition.current) {
      blockedTransition.current.retry();
    }
  }, []);

  /** Function to be called when users cancel the route transition */
  const cancelNavigation = useCallback(() => {
    setNavPromptShown(false);
  }, []);

  const setBlockedTransition = useCallback((transition: Transition) => {
    blockedTransition.current = transition;
    setNavPromptShown(true);
  }, []);

  const memoizedContextValue = useMemo(
    () => ({
      navPromptShown,
      setNavPromptShown,
      cancelNavigation,
      confirmNavigation,
      setBlockedTransition,
    }),
    [cancelNavigation, confirmNavigation, navPromptShown, setBlockedTransition]
  );

  return (
    <NavigationBlockerContext.Provider value={memoizedContextValue}>
      {children}
    </NavigationBlockerContext.Provider>
  );
}
